<script>
    import { dbClearAllInvalidItems, clearAllInvalidItems, invalidateItem,user_data, parseCityStateZip, userNotification, emitter, checkZip} from './stores.js';
    import * as yup from 'yup'; 
    import { debounce } from 'lodash';
    import { onMount } from "svelte";
    import Progresscomponent from "./components/progresscomponent.svelte";
    import Chipscompnent from './components/chipscompnent.svelte';
    import Dtemplate from "./components/detailedtemplate.svelte";
    
    let show_dropdown = false;

    onMount(async() => {

    });


    const formSchema = yup.object().shape({
        csz_element: yup
            .string()
            .required('Zip code or City,State is required to find the best rates.'),
    });
    let dropdown_element;
    async function searchCSZ(auto_submit){
        drop_down_items = [];
        dropdown_element.style.top = `${csz_element.offsetHeight}px`;
        show_dropdown = true;
        
        return new Promise(async (resolve, reject) => {
            await superagent
            .post('/api/obapi')
            .send({ action: 'search_zipcode', search_data: csz_element.value }) // sends a JSON post body
            .set('accept', 'json')
            .end((err, res) => {
    // console.log(err);
    // console.log(res);
                if(err !== null){
                    userNotification('error', 'Error:', err.toString());
                        reject(undefined);
                }else{
                    const jres = JSON.parse(res.text);
    // console.log(jres);
                    if(jres.st){
                        // let height = box.offsetHeight;
                        // element.style.width = "100px";
                        drop_down_items = jres.data;
                        if(drop_down_items.length > 0){
                            show_dropdown = true;
                        }else{
                            show_dropdown = false;
                        } 
                        resolve(jres.data);
                        // return tres.resolve(jres.data);
                        // return jres.data;
                    }else{
                        userNotification('error', 'Error:', res.msg);
                        reject(undefined);
                    }
                }
            });
        });

    }

    function doNext(){
        $emitter.emit('progressClick', '');
    }
    function selectDropdownItem(zc, ctty, st, cnty){

        $user_data.propertyzipcode = zc;
        $user_data.propertycity = ctty;
        $user_data.propertystate = st;
        $user_data.propertycounty = cnty;
        csz_value = `${ctty}, ${st} (${zc})`;
        show_dropdown = false;
        doNext();
    }

    let drop_down_items = [];
    // let debouncedDisplayDropdownMatches = debounce(function() {

    //     searchCSZ();

    // }, 200);


    let csz_element;
    async function checkNext() {
        clearAllInvalidItems();
        let res = false;
        await formSchema.validate({ csz_element: csz_element.value.trim() }).then(function (value) {
            res = true;
        }).catch(function (err) {
                invalidateItem(eval(err.path), err.errors[0]);
            res = false;
        });

        return res;
    }

    let csz_error = "";
    let error_label_element;


    function cszError(the_error){
        csz_error = "csz_error";
    }
    function clearCSZError(){
        csz_error = "";
    }

    let csz_value = "";

    function doKeyUp2(evt){
        dbClearAllInvalidItems();
        if(evt.keyCode === 13 && csz_error !== "csz_error" && evt.target.value.trim().length !== 0){
            // doGetStarted();
            $emitter.emit('progressClick', '');

            // console.log("trigger next here");
        }else{
            if(evt.target.value.trim().length !== 0){
                const is_good = checkZip(evt.target.value.trim());
                // console.log(is_good);
                if(is_good){
                    // dbClearAllInvalidItems(); 
                    clearCSZError();
                }else{
                    // invalidateItem(csz_element, "Please enter a valid zip code");
                    cszError();
                }

            }else{
                clearCSZError();
            }
        }

    
    }



//     function doKeyUp(evt) {
//         dbClearAllInvalidItems();
//         // console.log(evt);
//         if(evt.keyCode === 13){
//             // doGetStarted();
//         }else{
//             if(evt.target.value.trim().length === 0){
//                 show_dropdown = false;
//             }
//             if(evt.target.value.length >= 3){
//                 debouncedDisplayDropdownMatches();
//             }
//             const tdata = parseCityStateZip(evt.target.value);
//             // console.log(tdata);
//             if(tdata.st){
//                 if(tdata.type === "zip") $user_data.propertyzipcode = tdata.value[0];

//                 if(tdata.type === "cs") {
//                     $user_data.propertycity = tdata.value[0];
//                     $user_data.propertystate = tdata.value[1];                   
//                 }
//             }            
//             // const tdata = parseCityStateZip(evt.target.value);
//             // // console.log(tdata);
//             // if(tdata.st){
//             //     if(tdata.type === "zip") $user_data.propertyzipcode = tdata.value[0];

//             //     if(tdata.type === "cs") {
//             //         $user_data.propertycity = tdata.value[0];
//             //         $user_data.propertystate = tdata.value[1];                   
//             //     }
// // console.log(tdata);
//             // }
//             // $user_data.propertyzipcode = tval;                

//         }

//     }

</script>

<Dtemplate
progress_mobile_version={true}
>
    <Progresscomponent 
    pre_next_callback_function={checkNext}
    title="Where are you looking?"
    >
    <div class="formcontainer">
        <input bind:this={csz_element} class="floatingplaceholder {csz_error}" on:keyup={(e)=>{ doKeyUp2(e); }} bind:value={csz_value} type="text" placeholder="Zip code" autocomplete="off" />
        <span bind:this={error_label_element} class="floating-label2 {csz_error}">Please enter a valid zip code.</span>

    </div>
    </Progresscomponent>
</Dtemplate>

<style>
.formcontainer {
    margin-top: 40px;
    width: 60%;
    max-width: 350px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    /* border: 1px solid red; */
    box-sizing: border-box;
}
.formcontainer input {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;   
}
.dropdownsearchcontainer {
    z-index: 999;
    position: absolute;
    top: 45px;
    margin-left: auto;
    margin-right: auto;
    /* display: flex; */
    /* flex-direction: column; */
    width: 100%;
    max-height: 150px;
    background-color: white;
    overflow-y: scroll;
    box-sizing: border-box;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    border-left: 1px solid;
    border-bottom: 1px solid;
    border-right: 1px solid;
    border-color: var(--placeholdergray);
}
.dropdownsearchcontainer button {
    border: none;
    border-radius: 0px !important;
    /* border-bottom-right-radius: 0px !important; */
    background-color: white !important;
    color: var(--placeholdergray) !important;
    height: 40px;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-align: left !important;
}
.dropdownsearchcontainer button:hover {
    color: white !important;
    background-color: var(--placeholdergray) !important;
}
.dropdownsearchcontainer button:not(:last-of-type) {
    border-bottom: 1px solid #ccc;
}
.floating-label2 {
  position: absolute;
  pointer-events: none;
  left: 10px;
  top: 4px;
  font-size: 11px;
  transition: 0.2s ease all;
  color: var(--semperred);
  opacity: 0 !important;
}
.floating-label2.csz_error {
    opacity: 1 !important;
    transition: 0.2s ease all;
}
:global(.floatingplaceholder.csz_error) {
    border-color: var(--semperred);
    border-width: 3px;
    border-style:solid;
}

@media (max-device-width: 1024px), (max-width: 1023px) {
    .formcontainer {
        width: 100%;
        max-width: 280px;
    }

}
</style>